'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { X, ChevronLeft, ChevronRight, Expand } from 'lucide-react';

const photos = [
{
  id: 'photo-001',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1294012e5-1770501056157.png",
  alt: 'Bright modern living room with floor-to-ceiling windows and Mediterranean sea view at golden hour'
},
{
  id: 'photo-002',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_14b7848a4-1767976373764.png",
  alt: 'Spacious master bedroom with white linen, wooden floors, and sunlit balcony door'
},
{
  id: 'photo-003',
  src: "https://images.unsplash.com/photo-1592506119503-c0b18879bd5a",
  alt: 'Modern white kitchen with marble countertops, island bar stools, and pendant lights'
},
{
  id: 'photo-004',
  src: "https://images.unsplash.com/photo-1569566678407-293c9194cbcb",
  alt: 'Private terrace with lounge chairs, potted plants, and panoramic ocean horizon view'
},
{
  id: 'photo-005',
  src: "https://images.unsplash.com/photo-1722247478602-118537980be2",
  alt: 'Elegant bathroom with walk-in shower, white tiles, and natural wood vanity'
}];


export default function PhotoGallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openLightbox = (index: number) => {
    setActiveIndex(index);
    setLightboxOpen(true);
  };

  const prev = () => setActiveIndex((i) => (i - 1 + photos.length) % photos.length);
  const next = () => setActiveIndex((i) => (i + 1) % photos.length);

  return (
    <>
      {/* Gallery Grid */}
      <div className="mt-6 grid grid-cols-4 grid-rows-2 gap-2 h-[420px] rounded-2xl overflow-hidden">
        {/* Main large photo */}
        <div
          className="col-span-2 row-span-2 relative cursor-pointer group"
          onClick={() => openLightbox(0)}>
          
          <AppImage
            src={photos[0].src}
            alt={photos[0].alt}
            fill
            className="object-cover group-hover:brightness-90 transition-all duration-200"
            priority
            sizes="50vw" />
          
          <div className="absolute inset-0 flex items-end p-3 opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="bg-black/60 text-white text-xs font-600 px-2.5 py-1 rounded-lg flex items-center gap-1">
              <Expand size={12} /> View
            </span>
          </div>
        </div>

        {/* 4 smaller photos */}
        {photos.slice(1).map((photo, i) =>
        <div
          key={photo.id}
          className="relative cursor-pointer group"
          onClick={() => openLightbox(i + 1)}>
          
            <AppImage
            src={photo.src}
            alt={photo.alt}
            fill
            className="object-cover group-hover:brightness-90 transition-all duration-200"
            sizes="25vw" />
          
            {i === 3 &&
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                <span className="text-white text-sm font-700">+{photos.length - 4} more</span>
              </div>
          }
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightboxOpen &&
      <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center animate-fade-in" onClick={() => setLightboxOpen(false)}>
          <button
          className="absolute top-4 right-4 text-white/80 hover:text-white p-2 rounded-full hover:bg-white/10 transition-colors"
          onClick={() => setLightboxOpen(false)}>
          
            <X size={24} />
          </button>
          <button
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 rounded-full hover:bg-white/10 transition-colors"
          onClick={(e) => {e.stopPropagation();prev();}}>
          
            <ChevronLeft size={28} />
          </button>
          <button
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 rounded-full hover:bg-white/10 transition-colors"
          onClick={(e) => {e.stopPropagation();next();}}>
          
            <ChevronRight size={28} />
          </button>

          <div
          className="relative max-w-5xl w-full mx-16 aspect-video"
          onClick={(e) => e.stopPropagation()}>
          
            <AppImage
            src={photos[activeIndex].src}
            alt={photos[activeIndex].alt}
            fill
            className="object-contain"
            sizes="80vw" />
          
          </div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {photos.map((_, i) =>
          <button
            key={`dot-${i}`}
            onClick={(e) => {e.stopPropagation();setActiveIndex(i);}}
            className={`w-2 h-2 rounded-full transition-all ${i === activeIndex ? 'bg-white w-6' : 'bg-white/40'}`} />

          )}
          </div>
        </div>
      }
    </>);

}